import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/pricing/page.tsx");
